module.exports = __webpack_public_path__ + "img/infectious_disease.ee81b94f.png";